import { Table, TableCell } from '@isbj-redesign/frontend-components'
import React, { useState } from 'react'
import { RefetchOptions, QueryObserverResult } from 'react-query'
import { QuerySeitenProps, useQueryBereitstellungen } from './Api'
import { UncontrolledCollapsablePanel } from './CollapsablePanel'
import FileInfo from './FileInfo'
import HerunterladenButton from './HerunterladenButton'
import { useNow } from './hooks'
import { TablePagination } from './TablePagination'
import SortableTableHeader, { useSort } from './TableSortableHeader'
import { BereitstellungListItem, ErrorLike, Seite } from './types'

const refetchInterval = 10000

export default function BereitstellungenTable() {
    const [parameter, load] = useState<QuerySeitenProps>({ anzahl: 20 })
    const {
        parameter: sortParameter,
        sort,
        setSort,
    } = useSort<string>([
        { field: 'gueltigBis', direction: 'asc' },
        { field: 'name', direction: 'asc' },
    ])
    const { data, isLoading, refetch } = useQueryBereitstellungen({ ...parameter, sort: sortParameter }, { refetchInterval })

    if (!data?.eintraege?.length) return null

    return (
        <UncontrolledCollapsablePanel title="Bereitstellungen" loading={isLoading}>
            <Table caption="Bereitstellungen">
                <thead>
                    <tr>
                        <SortableTableHeader field="name" sort={sort} setSort={setSort}>
                            Dokument
                        </SortableTableHeader>
                        <SortableTableHeader field="fachverfahren" sort={sort} setSort={setSort}>
                            Fachverfahren
                        </SortableTableHeader>
                        <SortableTableHeader field="gueltigBis" sort={sort} setSort={setSort}>
                            Bereitstellung
                        </SortableTableHeader>
                    </tr>
                </thead>
                <tbody>
                    {data.eintraege.map((bereitstellung) => (
                        <BereitstellungTableRow key={bereitstellung.id} bereitstellung={bereitstellung} refetch={refetch} />
                    ))}
                </tbody>
            </Table>
            <TablePagination
                onPagination={(offset, limit) => load((old) => ({ ...old, start: offset, anzahl: limit }))}
                offset={data?.start || 0}
                limit={data?.anzahl || 0}
                total={data?.gesamt || 0}
            />
        </UncontrolledCollapsablePanel>
    )
}

function BereitstellungTableRow({
    bereitstellung,
    refetch,
}: {
    bereitstellung: BereitstellungListItem
    refetch: (options?: RefetchOptions | undefined) => Promise<QueryObserverResult<Seite<BereitstellungListItem>, ErrorLike>>
}) {
    const now = useNow()
    const gueltig = now <= new Date(bereitstellung.gueltigBis).getTime()

    return gueltig ? (
        <tr>
            <TableCell>
                <FileInfo name={bereitstellung.name || bereitstellung.dateiname} typ={bereitstellung.typ} groesse={bereitstellung.groesse} />
            </TableCell>
            <TableCell>{bereitstellung.fachverfahren || <em className="text-muted">Sammel-Bereitstellung</em>}</TableCell>
            <TableCell fitContent>
                <HerunterladenButton bereitstellung={bereitstellung} refetch={refetch} />
            </TableCell>
        </tr>
    ) : null
}
